import { Button, Select, Space } from "antd";
import { React, useState, useEffect, Image } from "react";
import { BASE_URL,BASE_IMAGE_URL, MAP_API_KEY, MAP_API_VERSION } from "../../service/apiConfig";
import IconLocation from "../../assets/ic_location_province.png";
import {
    Marker,
    MapContainer,
    Popup,
    TileLayer,
    useMapEvent,
    useMap,
    Circle,
} from "react-leaflet";
import { useMapEvents } from "react-leaflet";
import L from "leaflet";
import { useDispatch } from "react-redux";
import { updateCurrentLocation } from "../../features/currentLocationRedux/currentLocation";
import GoogleMapReact from 'google-map-react';
import Map4dMap from '../../components/map/Map4dMap'
import CustomMaker from "../../components/map/CustomMarker";
import CustomDragMaker from "../../components/map/CusstomDragMaker";
import { AutoComplete } from 'antd';
import OpenStreetMapApi from "../../service/openStreetMap";

const center = { lat: 10.823099, lng: 106.629662 };


const AnyReactComponent = ({ text }) =>  <div><img src={IconLocation} alt="Địa điểm" /></div>   
let setMakers = []
export default function MapManagement({location, onChange}) {
    const [maps, setMaps] = useState()
    const [position, setPosition] = useState(location);
    const [dataSearch, setDataSearch] = useState([]);
    const[mapOption, setMapOption] = useState({
        center: center,
        zoom: 15,
        controls: false
      })  
    setMakers.forEach(element => {
        element?.setMap(null)    
    });
    setMakers = []
    const { Option } = AutoComplete;

    const dispatch = useDispatch()
    const MapEvents = () => {       
        useMapEvents({
            click(e) {
                setPosition(e.latlng);
                onChange && onChange(e.latlng);
                dispatch(updateCurrentLocation(e.latlng));
            },
        });
                
        return position === null ? null : (
            <>              
                <Marker position={position}>
                </Marker>
            </>
        );
    }

    const onMapReady = (map, id) => {
        setMaps(map)
        let listener = map.addListener("click", (args) => {
            setMakers.forEach(element => {
                element?.setMap(null)    
            });
            setMakers = []
            
            console.log(args)
            const marker = createMarker(args.location, map)
            setMakers.push(marker)            
            onChange && onChange(args.location);
        })            
    }
    
    const createMarker = (location, map) => {
        const marker =  new window.map4d.Marker({
            position: location,
            iconView: `<div style=\"width: 16px; height: 26px; background-color: transparent; text-align: center; color: #000000;\">
            <img src="${BASE_IMAGE_URL}/images/marker.png"}/>
            </div>`,
          })
          
        marker.setMap(map)        
        return marker
    }
    const markerPanToLatLng = (marker, location) => {
        marker.map.panTo(location)
    }

    const loadMarker = (location, map) => {
        if (location?.lat != '' && location?.lng != null
        && map != null) {
            map.panTo(location)
            const marker = createMarker(location, map)
            setMakers.push(marker)
            markerPanToLatLng(marker, location)
        }        
    }
    
    const showAdd = async (lat, lng) => {
        const result = await OpenStreetMapApi.searchLocationMap4d(`${lat},${lng}`)

    }

    const handleSearch = async (value) => {
        const data = await OpenStreetMapApi.searchLocation(value)        
        setDataSearch(data)    
    }
    
    const renderSearch = () => (
        <div>
        <AutoComplete
            style={{ width: '100%' }}
            onSearch={handleSearch}
            placeholder="Tìm kiếm địa chỉ "
            onSelect={(val, opt ) => {
                const data = opt?.key.split(';')
                const lon = data[0]
                const lat = data[1]
                console.log(` OnSelect ${val}  opt=${opt?.key} lon=${lon} lat=${lat}`)
                const latlon = {
                    lng: lon, 
                    lat: lat
                }
                loadMarker(latlon, maps)
                onChange && onChange(latlon);
            }}>

        {dataSearch?.map((item) => (
        <Option key={
            item?.lon + ';' + item?.lat 
        } value={item?.display_name}  >
          {item?.display_name}
        </Option>
      ))}
         
        </AutoComplete> 
        </div>
    )

    return (  
        <>                
        {renderSearch()} 
        <Map4dMap className="map-container"   
        key="tripze_management"
        id={MAP_API_KEY}
        onMapReady={onMapReady}
        options={mapOption}
        accessKey={MAP_API_KEY}
        version={MAP_API_VERSION} >          
          {loadMarker(location, maps)}
      </Map4dMap>      
           
      </>     
      
    )

    // const GetCoordinates = () => {
    //     const map = useMap();
      
    //     useEffect(() => {
    //       if (!map) return;
    //       const info = L.DomUtil.create('div', 'legend');

    //       const positon = L.Control.extend({
    //         options: {
    //           position: 'bottomleft'
    //         },
      
    //         onAdd: function () {
    //           info.textContent = 'Click on map';
    //           return info;
    //         }
    //       })
      
    //       map.on('click', (e) => {
    //         info.textContent = e.latlng;
    //       })
      
    //       map.addControl(new positon());
      
    //     }, [map])
      
      
    //     return null
      
    //   }
    //   return (
    //     <GoogleMapReact
    //     style={{ minHeight: "100%", borderRadius: 24 }}
    //     bootstrapURLKeys={{ key: MAP_API_KEY }}
    //     defaultCenter={center}
    //     defaultZoom={12}
    //     className="map-container"
    //     onClick={(e) =>{
            
    //         const {
    //             lat,
    //             lng
    //         } = e
    //         setPosition({
    //             lat,lng});
    //         onChange && onChange({
    //             lat, lng
    //         });
    //         dispatch(updateCurrentLocation({lat, lng}));            
           
    //     }}
    //     >

    //      <AnyReactComponent
    //         lat={position ? position.lat : center.lat }
    //         lng={position ? position.lng : center.lng}
    //         text="My Marker"/>
    //   </GoogleMapReact>
    //   )
    // return (
    //     <MapContainer
    //         style={{ minHeight: "100%", borderRadius: 24 }}
    //         center={center}
    //         zoom={12}
    //         scrollWheelZoom={true}
    //         className="map-container"
    //     >              
    //         <TileLayer
    //             attribution="&copy; contributors"
    //             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    //         />
    //         <MapEvents></MapEvents>
    //     </MapContainer>
    // );
}
